import React from 'react';
import { Package } from 'phosphor-react';
import { useTheme } from 'styled-components/macro';

import * as S from './styles';

const ProductFirstTimeOrder: React.FC = () => {
  const theme = useTheme();

  return (
    <S.Wrapper>
      <Package size={36} color={theme.colors.green.default} />
    </S.Wrapper>
  );
};

export default ProductFirstTimeOrder;
